// extracted by mini-css-extract-plugin
export default {"title":"telepon-pembeli-properti_title__oeOlM"};